
"use client";

import React from "react";
import reactCSS from "reactcss";
import { Color, SketchPicker } from "react-color";
import tinycolor from "tinycolor2";
import { Stack, Form } from "react-bootstrap";

interface ColorPickerProps {
  // The currently selected color in hex format
  value?: string;
  // Function to call when the color changes
  setValueFunc: (colorHex: string) => void;
}
const defaultColor = "rgb(255,255,255)";
class ColorPicker extends React.Component<ColorPickerProps> {
  constructor(props: ColorPickerProps) {
    super(props);
    this.state = {
      displayColorPicker: false,
      color: tinycolor(this.props.value).toRgb() as Color,
    };
  }
  state = {
    displayColorPicker: false,
    color: tinycolor(this.props.value).toRgb() as Color,
  };

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({
      displayColorPicker: false,
      color: tinycolor(defaultColor).toRgb() as Color,
    });
  };

  handleChange = (color: any) => {
    this.setState({ color: color.rgb });
    this.props.setValueFunc(tinycolor(color.rgb).toHexString());
  };

  render() {
    if (this.props.value && this.props.value?.toString().length > 0) {
      this.state.color = tinycolor(this.props.value).toRgb() as Color;
    }

    if (!this.state.color) {
      this.state.color = tinycolor(defaultColor).toRgb() as Color;
    }

    const styles = reactCSS({
      default: {
        color: {
          width: "25px",
          height: "25px",
          background: `${tinycolor(this.state.color).toRgbString()}`,
        },
        swatch: {
          padding: "0px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer",
        },
        popover: {
          position: "absolute",
          zIndex: "2",
        } as React.CSSProperties,
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px",
        } as React.CSSProperties,
      },
    });

    return (
      <div>
        <Stack direction="horizontal" gap={2}>
          <div style={styles.swatch} onClick={this.handleClick}>
            <div style={styles.color} />
          </div>
          <Form.Control
            value={tinycolor(this.state.color).toHexString()}
            type="text"
            disabled
          />
        </Stack>
        {this.state.displayColorPicker ? (
          <div style={styles.popover}>
            <div style={styles.cover} onClick={this.handleClose} />
            <SketchPicker
              color={this.state.color}
              onChange={this.handleChange}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default ColorPicker;
